import { Drawer as MuiDrawer, DrawerProps as MuiDrawerProps, drawerClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useIsMobile } from '../../theme/hooks/useThemeHooks';
const defaultBorderRadius = '16px';

export type DrawerCloseReason = 'backdropClick' | 'escapeKeyDown' | 'closeButton';
export type DrawerOnClose = (event: object, reason: DrawerCloseReason) => void;

export interface DrawerProps extends Omit<MuiDrawerProps, 'onClose'> {
  onClose?: DrawerOnClose;
  borderRadius?: string;
}

type StyledDrawerProps = MuiDrawerProps & { borderRadius?: string };

const StyledDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'borderRadius',
})<StyledDrawerProps>(({ anchor, theme, borderRadius = defaultBorderRadius }) => ({
  [`& .${drawerClasses.paper}`]: {
    padding: '0 24px',
    ...(anchor === 'right' && {
      borderTopLeftRadius: borderRadius,
      borderBottomLeftRadius: borderRadius,
      width: '320px',
      [theme.breakpoints.up('md')]: { width: '464px' },
    }),
    ...(anchor === 'left' && {
      borderTopRightRadius: borderRadius,
      borderBottomRightRadius: borderRadius,
      width: '320px',
      [theme.breakpoints.up('md')]: { width: '464px' },
    }),
    ...(anchor === 'top' && {
      borderBottomLeftRadius: borderRadius,
      borderBottomRightRadius: borderRadius,
    }),
    ...(anchor === 'bottom' && {
      borderTopLeftRadius: borderRadius,
      borderTopRightRadius: borderRadius,
    }),
  },
}));

export function Drawer({ children, anchor, borderRadius, variant, ...props }: DrawerProps) {
  const isMobile = useIsMobile();
  let defaultAnchor = anchor;
  if (!defaultAnchor && variant === 'temporary') {
    defaultAnchor = isMobile ? 'bottom' : 'right';
  }
  return (
    <StyledDrawer anchor={defaultAnchor} variant={variant} borderRadius={borderRadius} {...props}>
      {children}
    </StyledDrawer>
  );
}
